export const SOUND_INTERVAL = {
  1: '1分',
  3: '3分',
  5: '5分',
  10: '10分',
  15: '15分',
} as const;

export const TEL_DELAY = {
  0: 'すぐ',
  3: '3分後',
  5: '5分後',
  10: '10分後',
  15: '15分後',
} as const;
